import React from 'react'
import routes from '../config/settings/routes'
import NavbarContainer from '../containers/Navbar/Navbar.container'
import ManagementSectionContainer from '../containers/ManagementMenu/ManagementMenu.container'
import BrandLayout from '../components/Layouts/BrandLayout'
import Heading from '../components/Layouts/Heading'
import ProtectBySession from '../components/Security/ProtectBySession'
import ProtectByFeatures from '../components/Security/ProtectByFeatures'
import NotFoundPage from './NotFound'
import Visor from '../containers/Visor/Visor'

/**
 * The Visor Page: embeds the COSMOS viewer.
 */
const VisorPage = () => {
  const title = 'Visor'

  // Rule for feature access
  const visorFeatureRule = features => features['com.cosmos/visor']

  return (
    <ProtectBySession rule={(hasSession, signedIn) => !!(hasSession && signedIn)}>
      <ProtectByFeatures rule={visorFeatureRule} fallback={() => <NotFoundPage />}>
        <BrandLayout
          navbar={<NavbarContainer />}
          header={<Heading title={title} tooltipContent="Visor de flota: GPS, cargas y predicciones." />}
          sidebar={<ManagementSectionContainer current={routes.visor} />}
          fullSection
        >
          <Visor />
        </BrandLayout>
      </ProtectByFeatures>
    </ProtectBySession>
  )
}

export default VisorPage
